import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { I18n } from 'react-redux-i18n';
import Select, { createFilter } from 'react-select';

import Dropdown, { components } from "@common/containers/fields/Dropdown";
import { getTestAttributes } from "@common/utils/tests";


import Tree, { getItem } from "../Tree";

import './TreeDropdown.styles.scss';

export default class TreeDropdown extends Component {
    static propTypes = {
        items: PropTypes.arrayOf(
            PropTypes.shape({
                id: PropTypes.number.isRequired,
                name: PropTypes.node.isRequired,
                children: PropTypes.array,
            })
        ),
        showFolderIcon: PropTypes.bool,
    };

    static defaultProps = {
        items: [],
        classes: {},
        placeholder: I18n.t('Select Folder'),
        showFolderIcon: false
    };

    state = {
        isOpen: false,
        selectedItem: {},
    };

    onChange = (id, item) => {
        this.close();
        this.props.onChange(id, item);
    }

    open = () => {
        this.setState((state) => ({
            ...state,
            isOpen: true,
        }));
    }

    close = () => {
        this.setState((state) => ({
            ...state,
            isOpen: false,
        }));
    }

    getMenuStyles = (css) => ({
        ...css,
        width: undefined,
    });

    getMenuPortalStyles = (css) => ({ ...css, zIndex: 9999 });

    getCustomControlComponent = (props) => {
        const { showFolderIcon } = this.props;
        const { children, ...controlProps } = props;

        if (!showFolderIcon) {
            return <components.Control {...controlProps}>{children}</components.Control>;
        }

        return (
            <components.Control {...controlProps}>
                <div className="TreeDropdown__control-with-icon">
                    <img 
                        src="gif/folder_closed.gif" 
                        alt="Folder" 
                        className="TreeDropdown__folder-icon"
                    />
                    {children}
                </div>
            </components.Control>
        );
    };

    getMenuListComponent = (props) => {

        const { items, className, value, collapseAfterLevel, classes } = this.props;
        
        return (
          <components.MenuList {...props} className={cx("TreeDropdown__menu", classes?.menu)}>
            <Tree
              collapseAfterLevel={collapseAfterLevel}
              className="TreeDropdown__menu__inner"
              items={items}
              value={value}
              onChange={this.onChange}
            />
          </components.MenuList>
        );
      };
      

    render() {
        const { items, placeholder, className, value, id, showFolderIcon, ...otherProps } = this.props;
        const { isOpen } = this.state;
        const selectedItem = getItem(value, items);

        return (
          <Dropdown
            className={cx("TreeDropdown", className)}
            id={id}
            selectedValue={selectedItem?.name}
            searchable={false}
            placeholder={placeholder}
            menuIsOpen={isOpen}
            onMenuOpen={this.open}
            onBlur={this.close}
            styles={{
              menu: this.getMenuStyles,
              menuPortal: this.getMenuPortalStyles,
            }}
            menuListComponent={items?.length ? this.getMenuListComponent : undefined}
            controlComponent={showFolderIcon ? this.getCustomControlComponent : undefined}
            {...otherProps}
          />
        );
    }
}
